import React from "react";

const SVG = ({
  style = {},
  fill = "#000",
  className = "",
  width="21.424", 
  height="21.424", 
  viewBox="0 0 21.424 21.424"
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path fill={fill} id="Path_23" d="M90.233 78.755a1.251 1.251 0 0 0-1.238-1.113q-3.7-.152-7.393-.185-.033-3.7-.185-7.393a1.251 1.251 0 0 0-1.117-1.238q-.774-.017-1.549 0a1.251 1.251 0 0 0-1.113 1.238q-.152 3.7-.185 7.393-3.7.033-7.393.185a1.251 1.251 0 0 0-1.238 1.113q-.017.774 0 1.549a1.251 1.251 0 0 0 1.238 1.113q3.7.152 7.393.185.033 3.7.185 7.393a1.251 1.251 0 0 0 1.113 1.238q.774.017 1.549 0a1.252 1.252 0 0 0 1.113-1.238q.152-3.7.185-7.393 3.7-.033 7.393-.185a1.251 1.251 0 0 0 1.242-1.117q.017-.771 0-1.545z" className="cls-1" data-name="Path 23" transform="translate(-68.817 -68.817)"/>
  </svg>
);

export default SVG;



// WEBPACK FOOTER //
// ./src/components/UI/Icons/Plus.js